// Job.jsx
import { Link } from 'react-router-dom'
import s from './styles.module.scss'
import { Modal } from 'components'

const resolveListingStatus = (job) => {
  if (!job) return 'closed'
  if (job.job_status === 'closed') return 'closed'
  return 'open'
}

export default function Job({ jobData = [], deleteHandler, toggleStatusHandler }) {
  return (
    <div className={s.main}>
      <div className={s.table}>
        <div className={s.tableHeading}>
          <div className={s.srNo}>S.No.</div>
          <div className={s.jobTitle}>Job Title</div>
          <div className={s.company}>Company</div>
          <div className={s.location}>Location</div>
          <div className={s.vacancies}>Experience</div>
          <div className={s.status}>Listing</div>
          <div className={s.actions}>Actions</div>
        </div>
        <div className={s.tableBody}>
          {jobData.map(
            (job, i) => {
              const {
                _id,
                job_title,
                company_name,
                city,
                experience,
                approvalStatus,
                rejectionMessage,
              } = job
              const listingStatus = resolveListingStatus(job)
              const isOpen = listingStatus === 'open'

              return (
              <div className={s.tableRowOuter} key={_id || i}>
                <div
                  className={s.tableRow}
                  style={{
                    border: approvalStatus
                    === 'Rejected'
                      ? '0.1rem solid var(--c-red)'
                      : approvalStatus
                      === 'Pending'
                      ? '0.1rem solid var(--c-primary)'
                      : '',
                    marginTop:approvalStatus
                    !== 'Approved' && '1.5rem',
                    borderTopLeftRadius:approvalStatus
                    !== 'Approved' && '0',
                    borderBottomLeftRadius: rejectionMessage && '0',
                    borderBottomRightRadius: rejectionMessage && '0',
                  }}
                >
                  {approvalStatus
 !== 'Approved' && (
                    <div
                      className={s.pendingStatus}
                      style={{
                        background:approvalStatus
                        === 'Rejected' && 'var(--c-red)',
                        borderRight: 'none'
                      }}
                    >
                      {approvalStatus
                      }
                    </div>
                  )}
                  <div className={s.srNo}>{i + 1}</div>
                  <div className={s.jobTitle}>{job_title}</div>
                  <div className={s.company}>{company_name}</div>
                  <div className={s.location}>{city}</div>
                  <div className={s.vacancies}>{experience}</div>
                  <div className={s.status}>
                    <span className={`${s.listingBadge} ${isOpen ? s.listingOpen : s.listingClosed}`}>
                      {isOpen ? 'Open' : 'Closed'}
                    </span>
                  </div>

                  <div className={s.actions}>
                  {typeof toggleStatusHandler === 'function' && (
                    <div
                      onClick={() =>
                        Modal.Confirm(
                          isOpen
                            ? `Mark "${job_title}" as Closed? Candidates will no longer be able to contact you for this role.`
                            : `Reopen "${job_title}"? It will show as Open again.`,
                          () => toggleStatusHandler(_id, isOpen ? 'closed' : 'open')
                        )
                      }
                      title={isOpen ? 'Mark as Closed' : 'Mark as Open'}
                    >
                      <span className='material-icons-outlined'>
                        {isOpen ? 'lock' : 'lock_open'}
                      </span>
                    </div>
                  )}
                  <Link to={`/jobs/update-opening-form/${_id}`} title='Edit Job'>
                      <span className='material-icons-outlined'>edit</span>
                    </Link>
                    <div
                      onClick={() =>
                        Modal.Confirm(
                          `Are you sure you want to delete job "${job_title}"?`,
                          () => deleteHandler(_id)
                        )
                      }
                      title='Delete Job'
                    >
                      <span className='material-icons-outlined'>delete</span>
                    </div>
                  </div>
                </div>
                {!!rejectionMessage && (
                  <div className={s.rejectionMessage}>
                    <div className={s.title}>
                      This job post is rejected, please review the message below and update accordingly.
                    </div>
                    {rejectionMessage}
                  </div>
                )}
              </div>
            )}
          )}
        </div>
      </div>
    </div>
  )
}
